import Utils from '../Services/Utils';

class FieldOption {
  constructor(item) {
    const tags_available = !Utils.isNull(item.tags_available) ?
      item.tags_available.map(tag => !Utils.isNull(tag.value) ? tag.value : tag) : null;
    const lockDDR = !Utils.isNull(item.lock_ddr) ? item.lock_ddr : item.lockDDR;
    this.score = !Utils.isNull(item.score) ? item.score : null;
    this.lockDDR = !Utils.isNull(lockDDR) ? lockDDR : false;
    this.value = item.value || item;
    this.tags_available = tags_available;
    this.id = item.id;
    this.componentId = item.componentId
  }

  static parse(item) {
    return new FieldOption(item);
  }

  serialize() {
    return {
      score: this.score,
      lock_ddr: this.lockDDR,
      value: this.value,
      tags_available: this.tags_available || [],
      id: this.id,
      componentId :this.componentId
    };
  }
}

export default FieldOption;